import { useEffect } from 'react';
import { atom, useRecoilState } from 'recoil';

export const currentDate = atom<string>({
    key: 'currentDate',
    default: new Date().toDateString()
});

/**
 * Custom hook to update the currentDate state.
 */
export function useDateChangeEffect() {
    const [date, setDate] = useRecoilState(currentDate);

    useEffect(() => {
        const checkDateChange = () => {
            const newDate = new Date().toDateString();
            if (newDate !== date) {
                setDate(newDate);
            }
        }

        // Check every minute for date change
        const interval = setInterval(checkDateChange, 60000);

        return () => clearInterval(interval);
    }, [date, setDate]);
}